import Component from '../abstracts/Component';

export default class LoaderComponent extends Component {
  get SELECTORS() {
    return {
      main: 'body',
      global: '[data-loader-global]',
    };
  }

  get CLASSES() {
    return {
      loading: 'loading'
    };
  }

  constructor() {
    super();
    this.globalLoaders = [];
  }

  showGlobalLoader(timeStamp) {
    return new Promise((resolve, reject) => {
      try {
        const main = document.querySelector(this.SELECTORS.main);
        this.globalLoaders.push(timeStamp);
        main.classList.add(this.CLASSES.loading);

        resolve(this.$customEvents.LOADER_EVENTS.visible);
      } catch (e) {
        reject(e);
      }
    });
  }

  showLocalLoader(el) {
    if (el.hasClass('loading-cta')) return;

    return new Promise((resolve, reject) => {
      try {
        el.addClass('loading-cta')
        el.attr('disabled','disabled');
        this.log('Show local loader', el);
      } catch (e) {
        reject(e);
      }
    });
  }

  hideLocalLoader(el) {
    return new Promise((resolve, reject) => {
      try {
        el.removeClass('loading-cta');
        el.removeAttr('disabled');
        el.addClass('success');
        setTimeout(() => {
          el.removeClass('success');
        }, 3000);
        this.log('Hide local loader');
      } catch (e) {
        reject(e);
      }
    });
  }

  hideGlobalLoader() {
    return new Promise((resolve, reject) => {
      try {
        const main = document.querySelector(this.SELECTORS.main);
        if (this.globalLoaders.length > 0) this.globalLoaders.pop();

        if (this.globalLoaders.length === 0) {
          main.classList.remove(this.CLASSES.loading);
          resolve(this.$customEvents.LOADER_EVENTS.hidden);
        } else {
          resolve(false);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  bindEvents() {

    this.$on(
      'submit',
      data => {
        let cta = $(data.event.currentTarget).find('[data-spinner]');
        this.showLocalLoader(cta);
      },
      'form'
    );

    this.$on(this.$customEvents.LOADER_EVENTS.showLocal, ({event, payload}) => {
      this.showLocalLoader(payload.button);
    });

    this.$on(this.$customEvents.LOADER_EVENTS.hideLocal, ({event, payload}) => {
      this.hideLocalLoader(payload.button);
    });

    this.$on(this.$customEvents.LOADER_EVENTS.show, ({event, payload}) => {
      this.showGlobalLoader(event.timeStamp).then(res => {
        this.$emit(res);
      });
    }, this.SELECTORS.global);

    this.$on(this.$customEvents.LOADER_EVENTS.hide, ({event, payload}) => {
      this.hideGlobalLoader().then(res => {
        if (res) this.$emit(res);
      });
    }, this.SELECTORS.global);
  }

  render() {
    this.bindEvents();
  }
}
